/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationEnrollmentGridQueryResponse,
  GetApiV1CourseregistrationEnrollmentGridQueryParams,
  GetApiV1CourseregistrationEnrollmentGrid401,
  GetApiV1CourseregistrationEnrollmentGrid500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentGrid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationEnrollmentGrid } from "../../clients/courseRegistrationEnrollmentController/getApiV1CourseregistrationEnrollmentGrid.ts";

export const getApiV1CourseregistrationEnrollmentGridQueryKey = (
  params?: GetApiV1CourseregistrationEnrollmentGridQueryParams,
) =>
  [
    { url: "/api/v1/courseregistration/enrollment/grid" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1CourseregistrationEnrollmentGridQueryKey = ReturnType<
  typeof getApiV1CourseregistrationEnrollmentGridQueryKey
>;

export function getApiV1CourseregistrationEnrollmentGridQueryOptions(
  params?: GetApiV1CourseregistrationEnrollmentGridQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1CourseregistrationEnrollmentGridQueryKey(params);
  return queryOptions<
    GetApiV1CourseregistrationEnrollmentGridQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentGrid401
      | GetApiV1CourseregistrationEnrollmentGrid500
    >,
    GetApiV1CourseregistrationEnrollmentGridQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationEnrollmentGrid(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna matrículas agrupadas por curso, polo e turma com suporte a filtros de empresa, polo, status, documentação, aluno, e-mail e CPF. O campo TotalPeopleCount indica o total de pessoas distintas no resultado filtrado (antes da paginação). Os children de cada grupo são carregados sob demanda via GET enrollment/grid/children. **(Requer Authorization para autenticação)**
 * @summary Lista matrículas paginadas com filtros (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/grid}
 */
export function useGetApiV1CourseregistrationEnrollmentGrid<
  TData = GetApiV1CourseregistrationEnrollmentGridQueryResponse,
  TQueryData = GetApiV1CourseregistrationEnrollmentGridQueryResponse,
  TQueryKey extends QueryKey = GetApiV1CourseregistrationEnrollmentGridQueryKey,
>(
  params?: GetApiV1CourseregistrationEnrollmentGridQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationEnrollmentGridQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationEnrollmentGrid401
          | GetApiV1CourseregistrationEnrollmentGrid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationEnrollmentGridQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1CourseregistrationEnrollmentGridQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentGrid401
      | GetApiV1CourseregistrationEnrollmentGrid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
